import { render, staticRenderFns } from "./WellnessRewardHistory.vue?vue&type=template&id=f09bccd4&"
import script from "./WellnessRewardHistory.vue?vue&type=script&lang=js&"
export * from "./WellnessRewardHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports